export enum ButtonType {
  Anchor = 'anchor',
  Button = 'button',
  Toggle = 'toggle',
  UnifiedApiButton = 'unified_api_button',
}
